import { S123gS123m01Component } from './s123g-s123m01.component';

export { S123gModule } from './s123g.module';

export const S123gSubComponentsMap = {
	
};

export const S123gComponentsMap = {
	"s123g-s123m01": S123gS123m01Component
};

export const S123gComponents = [
	S123gS123m01Component
];

